import { useQuery } from "react-query";
import { getOfficeCities } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useOfficeCities = () => {
  return useQuery("GetOfficeCities", getOfficeCities, {
    refetchOnWindowFocus: false,
  });
};
